import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { GetSignerLinkResponse } from './get-signer-link.types'

interface GetSignerLinkParams {
  envelopeId: string
  signerId: string
}

const getSignerLink = async ({
  envelopeId,
  signerId,
}: GetSignerLinkParams): Promise<GetSignerLinkResponse> => {
  const response = await apiClient.get<GetSignerLinkResponse>(
    `/v1/ecm/envelopes/${envelopeId}/signers/${signerId}/signature-link`,
  )
  return response.data
}

export const useGetSignerLink = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (params: GetSignerLinkParams) => getSignerLink(params),
    meta: {
      // Callers handle errors themselves (custom toasts / logging), so the
      // generic mutation error toast is skipped by default.
      skipErrorMessage: true,
      ...feedback,
    },
  })
}
